import { __rest } from "tslib";
import * as React from 'react';
import AngleRightIcon from '@patternfly/react-icons/dist/js/icons/angle-right-icon';
import { Button } from '../Button';
export var ClipboardCopyToggle = function ClipboardCopyToggle(_a) {
  var onClick = _a.onClick,
      id = _a.id,
      textId = _a.textId,
      contentId = _a.contentId,
      _a$isExpanded = _a.isExpanded,
      isExpanded = _a$isExpanded === void 0 ? false : _a$isExpanded,
      props = __rest(_a, ["onClick", "id", "textId", "contentId", "isExpanded"]);

  return React.createElement(Button, Object.assign({
    type: "button",
    variant: "control",
    onClick: onClick,
    id: id,
    "aria-labelledby": "".concat(id, " ").concat(textId),
    "aria-controls": "".concat(id, " ").concat(contentId),
    "aria-expanded": isExpanded
  }, props), React.createElement(AngleRightIcon, {
    "aria-hidden": "true"
  }));
};